import { useEffect, useRef, useState } from 'react';

import { TIME_FOR_TRANSACTION_MINTING } from 'shared/constants/timers';

import { useWaitForTransactionReceipt } from './use-web3';

export function useTransactionReceipt(hash?: `0x${string}` | string, startedAt?: Date) {
  const { data, isSuccess, isLoading, isError, error } = useWaitForTransactionReceipt({
    hash: hash as `0x${string}`,
  });

  const [limitExceed, setLimitExceed] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (!hash || !startedAt) {
      setLimitExceed(false);
      return;
    }

    if (isSuccess || isError) {
      setLimitExceed(false);
      return;
    }

    const elapsed = Date.now() - startedAt.getTime();
    const remaining = TIME_FOR_TRANSACTION_MINTING - elapsed;

    if (remaining <= 0) {
      setLimitExceed(true);
      return;
    }

    timeoutRef.current = setTimeout(() => setLimitExceed(true), remaining);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [hash, startedAt, isSuccess, isError]);

  return {
    data,
    isSuccess,
    isLoading,
    isError,
    error,
    limitExceed,
  };
}
